<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Perfil",
            items: [
                {
                    text: "Inicio",
                    href: "/"
                },
                {
                    text: "Perfil",
                    active: true
                }
            ],
            datos:{
                name: '',
                categoriaP_id: ''
            },
            categorizaciones:[
                //'Categorias',
                //'Marcas',
                'Turnos',
                'Canales',
                'Ubicaciones',
                //'Medidas',
                //'Clientes',
                'CODIGODEBARRA',
                'SKU',
            ],
            originalSucursal: {},
            sucursal: {
                id: 1, // ID de la sucursal
                name: '',
                direccion: '',
                pais:'',
                ciudad:'',
                telefono: '',
                documento: '',
                email: '',
                direccion_web: '',
                descripcion:'',
                categorizaciones: null,
                notificar: false,
                logo: '',
                imagen_url: '',
                estado: 1
            },
            editing: false,
            file: null,
            imagePreview:null,
            logo:false,
        };
    },
    mounted() {
        this.sucursal = this.user.sucursal;
        this.get_data()
        //console.log(this.sucursal)
    },
    computed:{
        imagen_nueva(){
            return this.imagePreview;
        }
    },
    methods: {
        get_data(){
            this.isLoading=true
            try {
                this.title='Perfil de '+this.sucursal.name;
                this.sucursal.categorizacionesSeleccionadas= this.sucursal.categorizaciones==null?[]:JSON.parse(this.sucursal.categorizaciones);
                this.imagePreview=this.sucursal.imagen_url
                this.$toasted.success('Datos cargados!');
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        toggleEdit() {
            this.originalSucursal = { ...this.sucursal };
            if (this.editing) {
                this.isLoading=true
                axios.put('/api/sucursals/'+this.sucursal.id,this.sucursal).then(res=>{
                if(res.data.estado){
                    this.sucursal=res.data.sucursal
                    window.location.reload(); 
                }else{
                    Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                }
                this.isLoading=false
            })
            }
            this.editing = !this.editing;
        },
        obtenerImagen(e){
            const file = e.target.files[0];
            if (file) {
                this.file=file
                const reader = new FileReader();
                reader.onload = (e) => {
                this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        cambiar_imagen(){
            this.isLoading=true
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('sucursal_id', this.sucursal.id);
            console.log(this.sucursal)
            axios.post('/api/guardar_image_perfil',formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(res=>{
                if (res.data.estado) {
                    console.log(res.data.subido)
                    console.log(res.data.guardado)
                    if(res.data.sucursal){
                        this.sucursal=res.data.sucursal
                        this.file=null
                        this.get_data()
                    }else{

                    }
                }
            })
            this.isLoading=false
        },
        cambiar_logo(){
            if (this.logo==false) {
                this.logo=true;
            }else{
                this.logo=false;
            }
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 form-group">
                        <h4 for="logo">Logo Empresa</h4>
                        <div class="text-center">
                            <img class="rounded-circle avatar-xl" v-if="imagen_nueva!=null" :src="imagen_nueva" alt="Vista previa de la imagen">
                        </div>
                    </div>
                    <div class="col-md-6 form-group">
                        <b-button class="mt-3 mb-4 float-right" variant="primary" @click="cambiar_logo">{{this.logo?'Cerrar sin cambios':'Subir Logo'}}</b-button>
                        <div class="mt-4" v-if="logo">
                            <b-form-group id="example text" class="mt-3" label="Cargar Imagen:" label-for="text">
                                <b-form-file
                                    v-model="file"
                                    accept="image/*"
                                    placeholder="Elegir Archivo"
                                    drop-placeholder="Drop file here..."
                                    @change="obtenerImagen"
                                ></b-form-file>
                            </b-form-group>
                            <button @click="cambiar_imagen" v-if="file!=null" class="btn btn-primary mt-3 float-right">Guardar imagen</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-3 shadow-sm border-light">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="text-primary mb-4">{{ editing ? sucursal.name : sucursal.name }}</h1>
                        <div v-if="editing">
                            <div class="form-group">
                                <label for="name"><i class="fas fa-store"></i> Nombre:</label>
                                <input type="text" id="name" v-model="sucursal.name" class="form-control border-primary">
                            </div>
                            <div class="form-group">
                                <label for="direccion"><i class="fas fa-map-marker-alt"></i> Dirección:</label>
                                <input type="text" id="direccion" v-model="sucursal.direccion" class="form-control border-primary">
                            </div>
                            <div class="form-group">
                                <label for="pais"><i class="fas fa-globe"></i> País:</label>
                                <input type="text" id="pais" v-model="sucursal.pais" class="form-control border-primary">
                            </div>
                            <div class="form-group">
                                <label for="ciudad"><i class="fas fa-city"></i> Ciudad:</label>
                                <input type="text" id="ciudad" v-model="sucursal.ciudad" class="form-control border-primary">
                            </div>
                            <div class="form-group">
                                <label for="telefono"><i class="fas fa-phone"></i> Teléfono:</label>
                                <input type="text" id="telefono" v-model="sucursal.telefono" class="form-control border-primary">
                            </div>
                            <div class="form-group">
                                <label for="documento"><i class="fas fa-id-card"></i> Nro Documento (Rut - sin puntos):</label>
                                <input type="text" id="documento" v-model="sucursal.documento" class="form-control border-primary">
                            </div>
                            <div class="form-group">
                                <label for="email"><i class="fas fa-envelope"></i> Email:</label>
                                <input type="email" id="email" v-model="sucursal.email" class="form-control border-primary">
                                <br>
                                <label for="notify_stock_minimum">
                                    <input type="checkbox" id="notify_stock_minimum" name="notify_stock_minimum" :true-value="1" :false-value="0" v-model="sucursal.notificar">
                                    Recibir notificaciones
                                </label>
                            </div>
                            <div class="form-group">
                                <label for="direccion_web"><i class="fas fa-link"></i> Dirección Web:</label>
                                <input type="text" id="direccion_web" v-model="sucursal.direccion_web" class="form-control border-primary">
                            </div>
                            <!-- Área de texto editable solo cuando se está en modo edición -->
                            <div class="form-group">
                                <label for="descripcion-local"><i class="fas fa-align-left"></i> Pequeña descripción de mi local:</label>
                                <textarea id="descripcion-local" class="form-control border-primary" v-model="sucursal.descripcion" maxlength="300" placeholder="Escribe una breve descripción de tu local..." rows="3"></textarea>
                                <small class="text-muted">Máximo 300 caracteres</small>
                                <p v-if="sucursal.descripcion && sucursal.descripcion.length >= 300" class="text-danger">
                                    Has alcanzado el límite de 300 caracteres
                                </p>
                            </div>
                        </div>
                        <div v-else>
                            <p v-if="sucursal.logo"><strong>Logo:</strong> <img :src="sucursal.logo" alt="Logo de la sucursal" class="img-thumbnail" style="max-width: 100px;"></p>
                            <p class="font-size-16"><i class="fas fa-map-marker-alt"></i> <strong>Dirección:</strong> {{ sucursal.direccion }}</p>
                            <p class="font-size-16"><i class="fas fa-globe"></i> <strong>País:</strong> {{ sucursal.pais }}</p>
                            <p class="font-size-16"><i class="fas fa-city"></i> <strong>Ciudad:</strong> {{ sucursal.ciudad }}</p>
                            <p class="font-size-16"><i class="fas fa-phone"></i> <strong>Teléfono:</strong> {{ sucursal.telefono }}</p>
                            <p class="font-size-16"><i class="fas fa-id-card"></i> <strong>Nro. Documento (Rut):</strong> {{ sucursal.documento }}</p>
                            <p class="font-size-16"><i class="fas fa-envelope"></i> <strong>Email:</strong> {{ sucursal.email }}</p>
                            <p class="font-size-16"><i class="fas fa-bell"></i> <strong>Recibir notificación:</strong> {{ sucursal.notificar == '1' ? 'Si' : 'No' }}</p>
                            <p class="font-size-16"><i class="fas fa-link"></i> <strong>Dirección Web:</strong> {{ sucursal.direccion_web }}</p>
                            <p class="font-size-16"><i class="fas fa-align-left"></i> <strong>Pequeña descripción de mi local:</strong> {{ sucursal.descripcion }}</p>
                        </div>
                        <div class="mt-3 float-right">
                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                <i class="fas fa-times"></i> Cancelar
                            </button>
                            <button @click="toggleEdit" class="btn btn-primary">
                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>
